























































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Moment from "moment-timezone";
import echarts from "echarts";
import XLSX from "@/lib/Common/excel";
import SearchTree from "@/lib/Common/searchtree";

class PageUserRequest extends PageRequest {
  keyword: string;
  areaId: number;
  startTime: string;
  endTime: string;
  operaType: number;
  meterId: string;
  isTotal: number;
  maxOrMin: string;
}

@Component({
  components: {},
})
export default class maxminvalue extends AbpBase {
  pagerequest: PageUserRequest = new PageUserRequest();
  areaTree: any[] = [];
  areaTreeList: any[] = [];
  searchName: string = "";
  columns: any[] = [];
  itemId: string = "0";
  height: number = 300;
  usebar: any; //图表
  useCount: number = 0;
  loadsear: boolean = false;
  splitnum: number = 0.15;
  get list() {
    return this.$store.state.hoursuserecord.list;
  }
  get loading() {
    return this.$store.state.hoursuserecord.loading;
  }
  pageChange(page: number) {
    this.$store.commit("hoursuserecord/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("hoursuserecord/setPageSize", pagesize);
    this.getpage();
  }
  changeSort(key) {
    this.pagerequest.sorting = key.key + " " + key.order;
    this.getpage();
  }
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length > 0) {
      if (item[0].id.length < 10) {
        this.pagerequest.areaId = item[0].id;
        this.pagerequest.meterId = "";
      } else {
        this.pagerequest.meterId = item[0].id;
        this.pagerequest.areaId = 0;
      }
    }
    this.$store.commit("hoursuserecord/setCurrentPage", 1);
    this.getpage();
  }
  getSearch() {
    this.$store.commit("hoursuserecord/setCurrentPage", 1);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    this.loadsear = true;
    if (this.pagerequest.maxOrMin == "1") {
      this.columns = this.totalcolumns;
    } else if (this.pagerequest.maxOrMin == "3") {
      this.columns = this.avecolumns;
    } else {
      this.columns = this.mincolumns;
    }
    this.usebar.resize();
    await this.$store
      .dispatch({
        type: "hoursuserecord/hoursMaxMinValue",
        data: this.pagerequest,
      })
      .then((val) => {
        this.loadsear = false;
        this.usebar.clear();
        this.usebar.setOption(this.$data.baroption(val.barData));
        this.$store.state.hoursuserecord.totalCount = val.rowCount;
        this.$store.state.hoursuserecord.list = val.tableData;
        this.useCount = val.useTotalCount;
      })
      .catch((err) => {
        this.loadsear = false;
        this.$Modal.info({
          title: this.L("Tips"),
          content: err,
        });
      });
  }
  get pageSize() {
    return this.$store.state.hoursuserecord.pageSize;
  }
  get totalCount() {
    return this.$store.state.hoursuserecord.totalCount;
  }
  get currentPage() {
    return this.$store.state.hoursuserecord.currentPage;
  }
  //时间改变
  changdate(val) {
    if (val.length > 1) {
      this.pagerequest.startTime = Moment(val[0], "YYYY-MM-DD HH:mm:ss")
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
      this.pagerequest.endTime = Moment(val[1], "YYYY-MM-DD HH:mm:ss")
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
    }
  }
  //搜索树形结构
  searchTree(value: any, treeList) {
    if (!value) {
      this.areaTree = this.areaTreeList;
      return;
    }
    //this.treedata = [];
    this.areaTree = SearchTree.searnchTree(value, treeList);
  }
  //区域树形
  async getAreaTree() {
    await this.$store
      .dispatch("area/getAreaLeftTree")
      .then((val) => {
        this.areaTree = val;
        this.areaTreeList = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  totalcolumns = [
    {
      type: "index",
      width: 80,
      align: "left",
      title: this.L("IndexNo"),
    },
    {
      title: this.L("Areas"),
      key: "areaName",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.areaName,
            },
          },
          params.row.areaName
        );
      },
    },
    {
      title: this.L("Meter"),
      key: "meterNo",
      sortable: true,
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.meterNo,
            },
          },
          params.row.meterNo
        );
      },
    },
    {
      title: this.L("MeterCaliber"),
      key: "meterCaliber",
      width: 130,
    },
    {
      title: this.L("ReadTime"),
      key: "recordTime",
      width: 150,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.recordTime == null
            ? ""
            : new Date(params.row.recordTime).toLocaleString("zh", {
              hour12: false,
            })
        );
      },
    },
    {
      title: this.L("MaxValue"),
      key: "thisUse",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("LastReadNum"),
      key: "thisRead",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("FirstReadNum"),
      key: "lastRead",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("Location"),
      key: "location",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.location,
            },
          },
          params.row.location
        );
      },
    },
  ];
  mincolumns = [
    {
      type: "index",
      width: 80,
      align: "left",
      title: this.L("IndexNo"),
    },
    {
      title: this.L("Areas"),
      key: "areaName",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.areaName,
            },
          },
          params.row.areaName
        );
      },
    },
    {
      title: this.L("Meter"),
      key: "meterNo",
      sortable: true,
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.meterNo,
            },
          },
          params.row.meterNo
        );
      },
    },
    {
      title: this.L("MeterCaliber"),
      key: "meterCaliber",
      width: 130,
    },
    {
      title: this.L("ReadTime"),
      key: "recordTime",
      width: 150,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.recordTime == null
            ? ""
            : Moment(params.row.recordTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      title: this.L("MinValue"),
      key: "thisUse",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("LastReadNum"),
      key: "thisRead",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("FirstReadNum"),
      key: "lastRead",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("Location"),
      key: "location",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.location,
            },
          },
          params.row.location
        );
      },
    },
  ];
  avecolumns = [
    {
      type: "index",
      width: 80,
      align: "left",
      title: this.L("IndexNo"),
    },
    {
      title: this.L("Areas"),
      key: "areaName",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.areaName,
            },
          },
          params.row.areaName
        );
      },
    },
    {
      title: this.L("Meter"),
      key: "meterNo",
      sortable: true,
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.meterNo,
            },
          },
          params.row.meterNo
        );
      },
    },
    {
      title: this.L("MeterCaliber"),
      key: "meterCaliber",
      width: 130,
    },
    {
      title: this.L("ReadTime"),
      key: "recordTime",
      width: 150,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.recordTime == null
            ? ""
            : Moment(params.row.recordTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      title: this.L("ThisUse"),
      key: "thisUse",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("AverageValue"),
      key: "averageValue",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("LastReadNum"),
      key: "thisRead",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("FirstReadNum"),
      key: "lastRead",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("Location"),
      key: "location",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.location,
            },
          },
          params.row.location
        );
      },
    },
  ];
  async created() {
    this.pagerequest.maxOrMin = "1";
    this.pagerequest.startTime = Moment()
      .startOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.pagerequest.endTime = Moment()
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.getAreaTree();
  }
  mounted() {
    if (window.innerHeight > 800) {
      (document.getElementById("echarts") as HTMLDivElement).style.height =
        "600px";
      this.height = 300;
    } else {
      (document.getElementById("echarts") as HTMLDivElement).style.height =
        "300px";
      this.height = 300;
    }
    this.usebar = echarts.init(
      document.getElementById("echarts") as HTMLDivElement
    );
    //自动缩放
    window.addEventListener("resize", () => {
      this.usebar.resize();
    });
  }
  //导出数据
  async exportdata() {
    this.loadsear = true;
    this.pagerequest.operaType = 1;
    await this.$store
      .dispatch({
        type: "hoursuserecord/hoursMaxMinValue",
        data: this.pagerequest,
      })
      .then((val) => {
        this.loadsear = false;
        this.exportListTotal(val.tableData);
      })
      .catch((err) => {
        this.loadsear = false;
        this.$Modal.info({
          title: this.L("Tips"),
          content: err,
        });
      });
  }
  //XLXS导出数据
  exportListTotal(list) {
    console.log(list);
    let title = [
      "区域",
      "表计",
      "读表时间",
      "最大/小值",
      "期末数",
      "期初数",
      "安装地址",
    ];
    let keylist = [
      "areaName",
      "meterNo",
      "recordTime",
      "thisUse",
      "thisRead",
      "lastRead",
      "location",
    ];
    if (this.pagerequest.maxOrMin == "3") {
      title = [
        "区域",
        "表计",
        "读表时间",
        "总用量",
        "平均值",
        "期末数",
        "期初数",
        "安装地址",
      ];
      keylist = [
        "areaName",
        "meterNo",
        "recordTime",
        "thisUse",
        "averageValue",
        "thisRead",
        "lastRead",
        "location",
      ];
    }
    let filename = Moment().format("YYYYMMDDHHmmss");
    const param = {
      title: title,
      key: keylist,
      data: list,
      autoWidth: true,
      filename: filename,
    };
    XLSX.export_array_to_excel(param);
  }
  data() {
    return {
      datepicker: {
        shortcuts: [
          {
            text: this.L("OneWeek"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              return [start, end];
            },
          },
          {
            text: this.L("OneMonth"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              return [start, end];
            },
          },
          {
            text: this.L("ThreeMonths"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
              return [start, end];
            },
          },
        ],
      },
      //柱形图参数
      baroption(bardto) {
        return {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: "line", // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          legend: {
            data: bardto.legend,
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true,
          },
          xAxis: [
            {
              type: "category",
              data: bardto.xAxis,
              axisLabel: {
                //坐标轴刻度标签的相关设置。
                interval: 0,
                rotate: "45",
              },
            },
          ],
          yAxis: [
            {
              type: "value",
            },
          ],
          series: bardto.series,
        };
      },
    };
  }
}
